var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShortBottomVine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 109,
    viewBox: "0 0 53 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4287_16559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 108.05C5.59 94.9102 15.09 80.0802 21.01 59.0002C32.23 19.0102 6.28 16.0602 12.28 6.00023C17.93 -3.46977 28.39 -1.09977 39.1 8.71023C49.02 17.7902 57.53 43.8602 49.7 64.4402C38.74 93.2502 4.79 106.5 0 108.05Z",
    fill: "#5F9340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 108.05C5.59 94.9102 15.09 80.0802 21.01 59.0002C32.23 19.0102 6.28 16.0602 12.28 6.00023C17.93 -3.46977 28.39 -1.09977 39.1 8.71023C49.02 17.7902 57.53 43.8602 49.7 64.4402C38.74 93.2502 4.79 106.5 0 108.05Z",
    fill: "url(#paint0_linear_4287_16559)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4287_16559",
    x1: 31.6579,
    y1: 96.3445,
    x2: 89.685,
    y2: 9.06751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AB240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2D14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4287_16559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.76,
    height: 108.05,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortBottomVine);
export default __webpack_public_path__ + "static/media/short_bottom_vine.bc34fb53a3aae0520afde555fb7776bd.svg";
export { ForwardRef as ReactComponent };